module.exports = __webpack_public_path__ + "static/media/broszura_IFA_1_C.113f6033.png";